import { render, staticRenderFns } from "./DynamicFormControl.vue?vue&type=template&id=70d48467&scoped=true"
import script from "./DynamicFormControl.vue?vue&type=script&lang=js"
export * from "./DynamicFormControl.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormControl.vue?vue&type=style&index=0&id=70d48467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d48467",
  null
  
)

export default component.exports